import * as React from 'react';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {RichIcon, RichIconType, Flex, Text, Section} from 'components/UIKit';
import * as locales from './locales';
import * as styles from './HowExchange.scss';

export type HowExchangeItem = {
  icon: RichIconType;
  heading: string;
  content: string;
};

export interface HowExchangeProps {
  items?: HowExchangeItem[];
}

function HowExchangeComponent({items, i18n}: HowExchangeProps & WithI18nProps) {
  const localizedItems: HowExchangeItem[] = items || locales[i18n.language].howItems;

  return (
    <Section
      heading={i18n.translate('howHeading')}
      subhead={i18n.translate('howSubHeading')}
      headingProps={{align: 'center', inheritColor: true}}
      subheadProps={{align: 'center', inheritColor: true}}
      className={styles.Wrapper}
    >
      <ul className={styles.Cards}>
        {localizedItems.map(({icon, heading, content}) => (
          <Flex wrapperComponent="li" key={icon} className={styles.Card}>
            <RichIcon icon={icon} size={40} className={styles.Icon} />
            <Flex direction="column">
              <Text type="h3" component="p" text={heading} className={styles.ContentHeading} />
              <Text text={content} component="p" secondary resetMargin />
            </Flex>
          </Flex>
        ))}
      </ul>
    </Section>
  );
}

export const HowExchange = withI18n({
  fallback: locales.en,
  id: 'HowExchange',
})(HowExchangeComponent);
